module.exports = __webpack_public_path__ + "63d4ae8271d69300f7cb48797fe731d5.png";